module.exports = __webpack_public_path__ + "img/stock1.a1d6e8e6.png";